export enum MessageLibraryRoutes {
  broadcast = "Broadcast Library",
  chat = "Hub Library",
}

export const messageLibraryKeys = Object.keys(MessageLibraryRoutes);

export type MessageLibraryKey = keyof typeof MessageLibraryRoutes;
